import orderInstance from '../instance'

const getWaiterSettings = (module) => {
  return orderInstance.get(`/waiterSettings/${module}`)
}

export default getWaiterSettings
